import Cookies from 'js-cookie';
import UserAuthService from '@Helpers/URLHelpers/UserAuthService';


class ResolveExportJobService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.RESOLVE_EXPORT_JOB = '/api/resolve-export-job';

        this.CREATE = '/create';
        this.GET_LIST_BY_FORM_ID = '/get-list/form-id/{formId}';
        this.GENERATE_REPORT_BY_FORM_ID = '/generate-report/export/form-id/{formId}';
        this.DELETE = '/delete';
    }

    async getExportListByFormId(formId) {
        try {
            let url = window.location.origin + this.RESOLVE_EXPORT_JOB + this.GET_LIST_BY_FORM_ID;
            url = url
                .replace('{formId}', formId);
            const exportJobList = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return exportJobList;
        } catch(err) {
            console.log(err);
        }
    }

    async generateReportByFormId(formId) {
        try {
            let url = window.location.origin + this.RESOLVE_EXPORT_JOB + this.GENERATE_REPORT_BY_FORM_ID;
            url = url
                .replace('{formId}', formId);
            const pdf = this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return pdf;
        } catch(err) {
            console.log(err);
        }
    }

    async createResolveExportJob(resolveBody) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.RESOLVE_EXPORT_JOB + this.CREATE;
            const resolveExportJob = this.fetch(url, {
                   method:'POST',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(resolveBody)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return resolveExportJob;
        } catch(err) {
            console.log(err);
        }
    }

    async deleteResolveExportJob(bodyMap) {
        try {
            let csrfToken = Cookies.get('XSRF-TOKEN');
            let url = window.location.origin + this.RESOLVE_EXPORT_JOB + this.DELETE;
            const deleteExportJob = this.fetch(url, {
                   method:'DELETE',
                   headers: {
                       'Content-Type': 'application/json',
                       'X-XSRF-TOKEN': csrfToken
                   },
                   body: JSON.stringify(bodyMap)
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            } else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return deleteExportJob;
        } catch(err) {
            console.log(err);
        }
    }
}

export default ResolveExportJobService;